// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import type { Country } from '@tectonics/prs/country';
import { EWalletList } from './ewallet-list';
import { Separator } from '../../../../../../commons/atoms/separator';
import {
  EWalletUssdFields,
} from './ewallet-fields/ussd';
import { Empty } from '@tectonics/look-and-feel/volcanes/atoms';
import { useUserInputValue } from '@tectonics/prs/user-input-values';


type props = {|
  country : Country,
|}

export function EWalletForm({ country } : props): Node {
  const allFeatures = useAllFeatures();
  const [selectedEWallet] = useUserInputValue('selectedEWallet');

  return(
    <Root>
      <IfFeature allFeatures={allFeatures} wanted="display_ewallet_accepts_brand">
        <TipMessage> {getTipMessage(country)} </TipMessage>
        <Separator direction="v" size={3} />
        <EWalletList />
        {renderEwalletFields(selectedEWallet)}
      </IfFeature>
    </Root>
  );
}

function getTipMessage(country: Country) : string {
  switch (country) {
    case 'br':
      return 'Selecione sua carteira digital abaixo: ';
    case 'cl':
      return 'Seleccione su billetera electrónica abajo: ';
    case 'mx':
      return 'Seleccione su cartera digital abajo: ';
    case 'ke':
    case 'ng':
      return 'Select your ewallet bellow: ';
    default:
      return '';
  }
}

function renderEwalletFields(selectedEWallet: string): Node {
  switch (selectedEWallet) {
    case 'ussd':
      return <EWalletUssdFields />;
    default:
      return <Empty />;
  }
}

const Root = styled.div``;

const TipMessage = styled.p``;
